module.exports = __webpack_public_path__ + "img/thumb_up.4fdcb55c.png";